// Copyright 2019 Sorama B.V.

import { containerless, customElement } from "aurelia-framework";

@containerless
@customElement("overlay")
export class Overlay {}
